import { useMe } from '@salescore/client-common'
import { loadViewParameters } from '@salescore/client-redux'
import { organizationHasFeature } from '@salescore/frontend-common'
import type { ReactElement } from 'react'

import { useInitializeViewState } from '../hooks/useInitializeViewState'
import { useVmid } from './VmidContext'

/**
 * useInitializeViewState を使って Redux ストアのビュー状態を初期化・クリーンアップするためのコンポーネント
 * 初期化中は `loadingElement` を表示する
 */
export const HydrateViewState = ({
  viewId,
  loadingElement,
  children,
}: {
  viewId: string
  loadingElement: ReactElement
  children: ReactElement
}): ReactElement => {
  const { pageSize: savedPageSize } = loadViewParameters(viewId)
  const me = useMe()
  const enableNxOnlyFeature = organizationHasFeature(me.organization, 'enable_nx_only_feature')
  const vmid = useVmid()

  const pageSize = savedPageSize ?? (enableNxOnlyFeature ? 1000 : 100)

  const isViewStateInitialized = useInitializeViewState({ vmid, viewId, pageSize })
  return isViewStateInitialized ? children : loadingElement
}
